
<template>
  <div class="topbar">
    <KeywordFilter :lookup="'tenants/fetch'" :limit="tenantsLimit"/>
    <div class="topbar__cell">
      <counters>
        <template slot="total">{{tenants.total}}</template>
      </counters>
      <div class="buttonset">
        <router-link class="btn btn--secondary" :to="{ name: 'export-tenants' }">{{ $t('top_bar.generate_report') }}</router-link>&nbsp;
        <!--<router-link class="buttonset__button btn btn--main" :to="{ name: 'add-tenant' }">{{ $t('top_bar.add_new_tenant') }}</router-link>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Autocomplete from 'common/Autocomplete';
import Counters from 'common/Counters';
import KeywordFilter from 'common/KeywordFilter';

export default {
  components: {
    Autocomplete,
    KeywordFilter,
    Counters,
  },
  data() {
    return {
    };
  },
  computed: mapGetters({
    tenants: 'landlord/tenants/tenants',
    tenantsLimit: 'landlord/tenants/limit',
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/tenants/Topbar.vue